import { ElementRef } from '@angular/core';
import { ModelPortfoliosService } from 'ModelPortfolioApp/ts/shared/services/model-portfolios.service';
import * as i0 from "@angular/core";
import * as i1 from "ModelPortfolioApp/ts/shared/services/model-portfolios.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = a0 => ({ "disabled": a0 });
const _c1 = () => [];
function TopPortfolioHoldingsComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "No data available");
    i0.ɵɵelementEnd();
} }
function TopPortfolioHoldingsComponent_tbody_22_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 17)(1, "td")(2, "a", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 12);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const portfolioItem_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", portfolioItem_r1.model_portfolio_url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(portfolioItem_r1.model_portfolio_name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(portfolioItem_r1.target_weighting);
} }
function TopPortfolioHoldingsComponent_tbody_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, TopPortfolioHoldingsComponent_tbody_22_tr_1_Template, 6, 3, "tr", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.topPortfolioHolders);
} }
function TopPortfolioHoldingsComponent_tbody_23_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6, "\u00A0");
    i0.ɵɵelementEnd()();
} }
function TopPortfolioHoldingsComponent_tbody_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 19);
    i0.ɵɵtemplate(1, TopPortfolioHoldingsComponent_tbody_23_tr_1_Template, 7, 0, "tr", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(4));
} }
export class TopPortfolioHoldingsComponent {
    constructor(eltRef, modelPortfoliosService) {
        this.eltRef = eltRef;
        this.modelPortfoliosService = modelPortfoliosService;
        this.USER = window.USER;
        this.paginationInfo = {
            current_page_num: 0,
            num_pages: 0,
            num_items: 0,
            start_index: 0,
            end_index: 0,
        };
        this.topPortfolioHolders = [];
        this.isFirstPage = true;
        this.isLastPage = true;
        this.tableHasNoData = true;
        this.securityId = eltRef.nativeElement.getAttribute('securityId');
        this.securityType = eltRef.nativeElement.getAttribute('securityType');
    }
    ngOnInit() {
        if (this.USER.authenticated) {
            this.getPageItems(1);
        }
        else {
            this.tableHasNoData = true;
        }
    }
    getPageItems(pageNum) {
        this.modelPortfoliosService
            .getTopPortfolioHolders(this.securityType, this.securityId, pageNum)
            .subscribe((response) => {
            this.paginationInfo = response.pagination_info;
            this.topPortfolioHolders = response.items;
            this.isFirstPage = this.paginationInfo.current_page_num === 1;
            this.isLastPage = this.paginationInfo.current_page_num === this.paginationInfo.num_pages;
            this.tableHasNoData = this.topPortfolioHolders.length === 0;
        });
    }
    getNextPage() {
        if (this.paginationInfo.num_pages > this.paginationInfo.current_page_num) {
            this.getPageItems(this.paginationInfo.current_page_num + 1);
        }
    }
    getPreviousPage() {
        if (this.paginationInfo.current_page_num > 1) {
            this.getPageItems(this.paginationInfo.current_page_num - 1);
        }
    }
}
TopPortfolioHoldingsComponent.ɵfac = function TopPortfolioHoldingsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TopPortfolioHoldingsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.ModelPortfoliosService)); };
TopPortfolioHoldingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TopPortfolioHoldingsComponent, selectors: [["ycn-top-portfolio-holdings"]], standalone: false, decls: 24, vars: 13, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action", "col-auto", "text-gray-30"], [1, "panel-action"], ["data-test-id", "get-previous-page-button", 1, "btn", "btn-secondary", 3, "click", "ngClass"], ["ycnIcon", "", 3, "name"], ["data-test-id", "get-next-page-button", 1, "btn", "btn-secondary", 3, "click", "ngClass"], [1, "panel-content"], ["class", "panel-data-empty-message ajust-vertical", "data-test-id", "no-data-available-message", 4, "ngIf"], [1, "table", "table-hover"], [1, "text-right"], [4, "ngIf"], ["data-test-id", "no-data-default-table", 4, "ngIf"], ["data-test-id", "no-data-available-message", 1, "panel-data-empty-message", "ajust-vertical"], ["data-test-id", "model-portfolio-row-item", 4, "ngFor", "ngForOf"], ["data-test-id", "model-portfolio-row-item"], [3, "href"], ["data-test-id", "no-data-default-table"], [4, "ngFor", "ngForOf"]], template: function TopPortfolioHoldingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Top Portfolio Holders");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5)(8, "a", 6);
        i0.ɵɵlistener("click", function TopPortfolioHoldingsComponent_Template_a_click_8_listener() { return ctx.getPreviousPage(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(9, "svg", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "div", 5)(11, "a", 8);
        i0.ɵɵlistener("click", function TopPortfolioHoldingsComponent_Template_a_click_11_listener() { return ctx.getNextPage(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(12, "svg", 7);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵtemplate(14, TopPortfolioHoldingsComponent_div_14_Template, 2, 0, "div", 10);
        i0.ɵɵelementStart(15, "table", 11)(16, "thead")(17, "tr")(18, "th");
        i0.ɵɵtext(19, "Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "th", 12);
        i0.ɵɵtext(21, "%\u00A0Weight");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(22, TopPortfolioHoldingsComponent_tbody_22_Template, 2, 1, "tbody", 13)(23, TopPortfolioHoldingsComponent_tbody_23_Template, 2, 2, "tbody", 14);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate2(" ", ctx.paginationInfo.current_page_num, " of ", ctx.paginationInfo.num_pages, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0, ctx.isFirstPage));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-back");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0, ctx.isLastPage));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-collapse");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.tableHasNoData);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", !ctx.tableHasNoData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tableHasNoData);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.IconDirective], encapsulation: 2 });
